<template>
    <span v-if="icons.length >= 0" class="activity-feed-item-icons">
        <template v-for="icon in filteredIcons">
            <span
                class="icon"
                :key="icon.name"
                :style="icon.style"
                :title="icon.name"
                v-if="icon.name !== 'Predictive'"
            >
                {{ icon.display }}
            </span>
            <PredictiveIndicator v-else :key="icon.name" />
        </template>
    </span>
</template>

<script setup>
import { computed } from 'vue'
import PredictiveIndicator from '../evasion/PredictiveIndicator.vue'

const ICONS = Object.fromEntries(
    [
        { name: 'Pending Verification', display: 'PEND', style: { 'background-color': '#666666', color: '#FFFFFF' } },
        { name: 'Low Severity', display: 'LOW', style: { 'background-color': '#FFFF00', color: '#000000' } },
        { name: 'High Severity', display: 'HIGH', style: { 'background-color': '#FF0000', color: '#FFFFFF' } },
        { name: 'Critical', display: 'CRITICAL', style: { 'background-color': '#000000', color: '#FFFFFF' } },
        { name: 'Outlier', display: 'OUTLIER', style: { 'background-color': '#48A2B8', color: '#FFFFFF' } },
    ].map(icon => [icon.name, icon])
)

const props = defineProps({
    icons: {
        type: Array,
        default: () => [],
    },
})

const filteredIcons = computed(() =>
    props.icons.map(
        i =>
            ICONS[i] ?? {
                name: i,
                display: i,
                style: { 'background-color': '#000000', color: '#FFFFFF' },
            }
    )
)
</script>

<style scoped>
.activity-feed-item-icons {
    display: flex;
    flex-wrap: wrap;
    gap: 4px;
}

span.icon {
    display: inline-block;
    border-radius: 10px;
    padding: 0 8px;
    margin-right: 4px;
    font-size: 10px;
    line-height: 18px;
    text-align: center;
}
</style>
